export default {"src":"/_next/static/media/MY.6cb41ec6.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};